























// @ is an alias to /src
import { Component, Vue } from 'vue-property-decorator'
import { toStringDictionary } from '@/utils/groupBy'
import { AloCommande, getDefaultAloCommande } from '@/models/alo/AloCommande'
import { formatFinValidite } from '@/filters/formatFinValidite'
import { tva } from '@/filters/tva'
import { formatCurrency } from '@/filters/currency'

@Component({
  name: 'ReadItems',    
   props: {
    commande:{      
      default:getDefaultAloCommande()
    },
    loading:{
      type:Boolean,
      default:false
    }
  }
})
export default class ReadItems extends Vue {
  private commande!:AloCommande
  private loading!:boolean  

  get cmdRows(){
    return this.commande.rows.map(r => {return {
          ...r,
          prixTotal:r.crwQty*r.crwTarif, 
          finValidite: formatFinValidite(this.commande.cmdDatpaiement,r.forfait?.cftValiditeM!),
          tva: r.crwQty * r.crwTarif * (1 - 1/(1 + r.crwTva / 10000))

        }
      })
  }

  private headersProduit = [            
    { text: 'Libelle', value: 'libelle' },           
    { text: 'Fin de validité', value: 'finValidite', width:200 },      
    { text: 'Quantite', value: 'crwQty', width:110 },    
    { text: 'Prix TTC', value: 'crwTarif', width:110 },   
    { text: 'TVA', value: 'crwTva', width:110},
    { text: 'Taxe', value: 'tva', width:110},
    { text: 'Total TTC', value: 'prixTotal', width:110}, 
  ]
 
}
